import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {

        // STATUS -----------------------------------------------------------------------------------------------------------

        /// <summary>
        /// Returns a list of all job statuses, with only substatuses included.
        /// </summary>
        async GetJobStatusListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'GetJobStatusListFromFilter' };
            var response = await client().get(store.state.apiRouteRoot + "JobStatus/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },

        /// <summary>
        /// Returns a list of all job statuses, with colors, icons, substatuses and count of jobs included.
        /// </summary>
        async GetJobStatusMap() {
            var meta = { clientApiMethod: 'GetJobStatusMap' };
            var orderDepartmentfilter = store.getters["prefrences/Prefrence"]("JobListFilterOrderDepartmentDefault");
            var params = { OrderDepartmentFilter: orderDepartmentfilter };
            var response = await client().get(store.state.apiRouteRoot + 'JobStatus/GetAll', { params: params, meta: meta })
            return response?.data;
        },

        /// <summary>
        /// Useed to modify a status. Color, Name and Icon are the only fields that can be changed.
        /// </summary>
        async changeJobStatus(status) {
            var meta = {
                clientApiMethod: 'changeJobStatus',
                input: { status },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.status") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "JobStatus", status, { meta: meta })
            return response?.data;
        },



        // SUBSTATUS --------------------------------------------------------------------------------------------------------

        /// <summary>
        /// Returns a list of substatuses.
        /// </summary>
        async GetJobSubStatusListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'GetJobSubStatusListFromFilter' };
            var response = await client().get(store.state.apiRouteRoot + "JobSubStatus/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },

        async addJobSubStatus(substatus) {
            var meta = {
                clientApiMethod: 'addJobSubStatus',
                input: { substatus },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.substatus") })
            }
            var response = await client().post(store.state.apiRouteRoot + "JobSubStatus/", substatus, { meta: meta })
            return response?.data;
        },

        /// <summary>
        /// Used to modify a substatus. Name and ParentId the only fields that can be changed. 
        /// Changing ParentId should be done with caution as it does not move that status of the jobs.
        /// </summary>
        async changeJobSubStatus(substatus) {
            var meta = {
                clientApiMethod: 'changeJobSubStatus',
                input: { substatus },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.substatus") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "JobSubStatus/", substatus, { meta: meta })
            return response?.data;
        },
    }
}